"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppService = void 0;
require("rxjs/add/operator/toPromise");
const router_1 = require("@angular/router");
const bid_data_filter_service_1 = require("./bid-data-filter.service");
const bid_data_rollup_service_1 = require("./bid-data-rollup.service");
const bid_data_service_1 = require("./bid-data.service");
//INTERNAL LIBRARY BITS
const bidder_service_1 = require("./bidder.service");
const clients_service_1 = require("./clients.service");
const data_level_service_1 = require("./data-level.service");
const data_metric_service_1 = require("./data-metric.service");
const data_source_service_1 = require("./data-source.service");
const demand_partner_service_1 = require("./demand-partner.service");
const demand_partner_type_service_1 = require("./demand-partner-type.service");
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const integration_service_1 = require("./integration.service");
const loading_service_1 = require("./loading.service");
const organizations_service_1 = require("./organizations.service");
const permission_service_1 = require("./permission.service");
const permissions_service_1 = require("./permissions.service");
const price_bucket_service_1 = require("./price-bucket.service");
const roles_service_1 = require("./roles.service");
const size_service_1 = require("./size.service");
const token_service_1 = require("./token.service");
const user_service_1 = require("./user.service");
const users_service_1 = require("./users.service");
const version_service_1 = require("./version.service");
let AppService = class AppService {
    constructor(_bidder, _organizations, _clients, _roles, _permissions, _permission, _users, _user, _demandPartners, _demandPartnerTypes, _size, _version, _router, _http, _loading, _priceBucket, _integration, _bidData, _bidDataFilter, _bidDataRollup, _dataSource, _dataMetric, _dataLevel) {
        this._bidder = _bidder;
        this._organizations = _organizations;
        this._clients = _clients;
        this._roles = _roles;
        this._permissions = _permissions;
        this._permission = _permission;
        this._users = _users;
        this._user = _user;
        this._demandPartners = _demandPartners;
        this._demandPartnerTypes = _demandPartnerTypes;
        this._size = _size;
        this._version = _version;
        this._router = _router;
        this._http = _http;
        this._loading = _loading;
        this._priceBucket = _priceBucket;
        this._integration = _integration;
        this._bidData = _bidData;
        this._bidDataFilter = _bidDataFilter;
        this._bidDataRollup = _bidDataRollup;
        this._dataSource = _dataSource;
        this._dataMetric = _dataMetric;
        this._dataLevel = _dataLevel;
    }
    //functions as a initial call list and a master reset call as well
    //WHEN ADDING, BE MINDFUL OF ANY DEPENDENCIES AND ORDERING OF CALLS
    // NOTE ***
    // All promises inside of the all() method will need to be screened as to whether they should be filtered
    // fetchBidder, fetchBidDataFilter, fetchBidData all have respective policies that dicatate their access
    init(route_1) {
        return __awaiter(this, arguments, void 0, function* (route, restart = false) {
            this.route = route;
            this._loading.startProgress(5, "Logging in...");
            yield this._user.pull(restart);
            this._loading.progress(`Loading Platform...`);
            yield Promise.all([
                this._dataSource.pull(),
                this._organizations.pull(),
                this._roles.pull(),
                this._permissions.pull(),
                this.fetchIntegration(),
                this.fetchClients(),
                this.fetchUsers(),
            ]);
            yield Promise.all([
                // Pulling demandPartners, since currently control center and Dashboard validations rely on it
                this._demandPartners.pull(),
                this._demandPartnerTypes.pull(),
                this._size.pull(),
                this._dataMetric.pull(),
                this._bidDataRollup.pull(),
                this._dataLevel.pull(),
                this._priceBucket.pull(),
                this._version.pull(),
            ]);
            this._loading.progress("Loading Dashboard Filters...");
            yield this._bidDataFilter.setProductFilters();
            yield this.fetchBidDataFilter();
            this._loading.progress("Loading Dashboard Data...");
            yield Promise.all([this.fetchBidder(), this.fetchBidData()]);
            yield this.navigate();
            this._loading.progress(`Platform Loaded`);
        });
    }
    fetchUsers() {
        return new Promise((resolve, reject) => {
            this._users
                .pull()
                .then((res) => {
                resolve(res);
            })
                .catch((err) => {
                err.status === 401 ? resolve(null) : reject(err);
            });
        });
    }
    fetchIntegration() {
        return new Promise((resolve, reject) => {
            this._integration
                .pull()
                .then((res) => {
                resolve(res);
            })
                .catch((err) => {
                err.status === 401 ? resolve(null) : reject(err);
            });
        });
    }
    fetchClients() {
        return new Promise((resolve, reject) => {
            this._clients
                .pull()
                .then((res) => {
                resolve(res);
            })
                .catch((err) => {
                err.status === 401 ? resolve(null) : reject(err);
            });
        });
    }
    fetchBidder() {
        return new Promise((resolve, reject) => {
            this._bidder
                .getBidders()
                .then((res) => {
                resolve(res);
            })
                .catch((err) => {
                err.status === 401 ? resolve(null) : reject(err);
            });
        });
    }
    fetchBidDataFilter() {
        return new Promise((resolve, reject) => {
            this._bidDataFilter
                .pull()
                .then((res) => {
                resolve(res);
            })
                .catch((err) => {
                err.status === 401 ? resolve(null) : reject(err);
            });
        });
    }
    fetchBidData() {
        return new Promise((resolve) => {
            this._bidData
                .pull()
                .then((res) => {
                resolve(undefined);
            })
                .catch((err) => {
                err.status === 401
                    ? resolve(null)
                    : (this._bidData.handleBidDataRequestError(err), resolve(null));
            });
        });
    }
    navigate() {
        if (this.route && this.route != "refresh") {
            return this._router.navigate([this.route], {
                queryParams: this._http.qParams,
            });
        }
        else if (this.shouldRedirectToPortal()) {
            return this._router.navigateByUrl("/portal");
        }
        else {
            return this._router.navigate(["/welcome"], {
                queryParams: { unexpected: this.isUnexpectedWelcome() },
            });
        }
    }
    /**
     * Checks for any on init errors, that should be redirect to welcome with an unexpected error message
     */
    isUnexpectedWelcome() {
        // if we were unable to load the bidders
        return !this._bidder.get();
    }
    shouldRedirectToPortal() {
        const perms = this._permission.get();
        // fow now biddr connect users branding should not see the default
        // welcome when bidder are missing instead should redirect to portal
        return ((perms && perms["system-branding--biddr_connect"]) ||
            // eventually everything should be redirected to portal if bidders were found
            // otherwise welcome page should be shown
            (this._bidder.get() && this._bidder.get().length > 0));
    }
};
exports.AppService = AppService;
exports.AppService = AppService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [bidder_service_1.BidderService,
        organizations_service_1.OrganizationsService,
        clients_service_1.ClientsService,
        roles_service_1.RolesService,
        permissions_service_1.PermissionsService,
        permission_service_1.PermissionService,
        users_service_1.UsersService,
        user_service_1.UserService,
        demand_partner_service_1.DemandPartnerService,
        demand_partner_type_service_1.DemandPartnerTypeService,
        size_service_1.SizeService,
        version_service_1.VersionService,
        router_1.Router,
        token_service_1.TokenService,
        loading_service_1.LoadingService,
        price_bucket_service_1.PriceBucketService,
        integration_service_1.IntegrationService,
        bid_data_service_1.BidDataService,
        bid_data_filter_service_1.BidDataFilterService,
        bid_data_rollup_service_1.BidDataRollupService,
        data_source_service_1.DataSourceService,
        data_metric_service_1.DataMetricService,
        data_level_service_1.DataLevelService])
], AppService);
//# sourceMappingURL=app.service.js.map